// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify' // path to vuetify export

import BootstrapVue from 'bootstrap-vue'

import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import {when, isObject} from 'vue-resource/src/util'
import VueCookies from 'vue-cookies'
import Loading from 'vue-loading-overlay';

import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import 'mapbox-gl/dist/mapbox-gl.css'
import 'mapbox-gl-controls/theme.css'
import '@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css'
import "@fontsource/roboto";
//import Chat from './vue-beautiful-chat.umd.min'
import Plugin from './chat/index'
import vSelect from 'vue-select'
import HandyScroll from "vue-handy-scroll";

import { MonthPicker } from 'vue-month-picker'
import { MonthPickerInput } from 'vue-month-picker'

Vue.use(MonthPicker)
Vue.use(MonthPickerInput)

Vue.component('handy-scroll', HandyScroll);
Vue.component('vue-select', vSelect);

import { MdCard} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
Vue.use(MdCard);

Vue.use(Plugin);

import FloatingVue from 'floating-vue'
FloatingVue.options.themes.tooltip.delay.show = 300

Vue.use(FloatingVue)


//import ChatWindow from 'vue-advanced-chat'
//import 'vue-advanced-chat/dist/vue-advanced-chat.umd'
//Vue.component('chat-window', ChatWindow)

import { Settings } from 'luxon'

Settings.defaultLocale = 'de';

import VueHtmlToPaper from './vue-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=no',

  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
};
Vue.use(VueHtmlToPaper, options);

import PrimeVue from 'primevue/config';

Vue.use(PrimeVue);


Vue.use(Datetime);

Vue.use(Loading, {
  color: 'blue',
  canCancel: false,
  height: 100,
  width: 100,
  opacity: 0.7
});

// todo
// cssVars()

Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(VueCookies);


/* eslint-disable no-new */
new Vue({
  vuetify,
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  PrimeVue
});

Vue.http.interceptors.push(function(request) {
  request.credentials=true;
  if (navigator.userAgent === "BisOfficeMobile" || navigator.userAgent.startsWith("Windows - BisOffice")) {
    request.headers.set('Authorization', sessionStorage.getItem("authorisation"));
    request.headers.set('Customer-Number', sessionStorage.getItem("customer_number"));
    request.headers.set('Customer-Package', sessionStorage.getItem("customer_package"));
  }
});
